/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_Delete_Confirm_TitleInputs */



/**
* | output |
* | --- |
* | "Delete Deck?" |
*
* @param {Decks_Delete_Confirm_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_delete_confirm_title = /** @type {((inputs?: Decks_Delete_Confirm_TitleInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_Delete_Confirm_TitleInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer le deck ?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Eliminar deck?")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Excluir deck?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Eliminare il deck?")
	return /** @type {LocalizedString} */ ("Delete Deck?")
});